export default __webpack_public_path__ + "static/media/icon_Bell.1e4c676f.svg";